
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * MarginCalculationType enum
 */
class MarginCalculationType {
  /**
   * Initialize enum with a given value
   * @param {MarginCalculationType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof MarginCalculationType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!MarginCalculationType}
   * @param {!MarginCalculationType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof MarginCalculationType)) {
      throw new TypeError('Instance of MarginCalculationType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!MarginCalculationType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!MarginCalculationType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === MarginCalculationType.SimpleMidPrice.value) {
      return 'SimpleMidPrice'
    }
    if (this.value === MarginCalculationType.CFD.value) {
      return 'CFD'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!MarginCalculationType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!MarginCalculationType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!MarginCalculationType} Created enum
   */
  static fromObject (other) {
    return new MarginCalculationType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
MarginCalculationType.SimpleMidPrice = new MarginCalculationType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
MarginCalculationType.CFD = new MarginCalculationType(0 + 1)

export { MarginCalculationType };

/**
 * Fast Binary Encoding MarginCalculationType field model
 */
class FieldModelMarginCalculationType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelMarginCalculationType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelMarginCalculationType}
   * @param {MarginCalculationType=} defaults Default value, defaults is new MarginCalculationType()
   * @returns {!MarginCalculationType} Result value
   */
  get (defaults = new MarginCalculationType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new MarginCalculationType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelMarginCalculationType}
   * @param {!MarginCalculationType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelMarginCalculationType };
